import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
import _findInstanceProperty from "@babel/runtime-corejs3/core-js/instance/find";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Select2 from "@Shared/components/inputs/select2";
import { defineComponent } from "@vue/composition-api";
import { DOCUMENT_STATUSES, documentStatusIcons } from "@Shared/@Utils/constants";
export default defineComponent({
  name: "DocumentStatusSelect",
  components: {
    Select2
  },
  props: {
    id: {
      type: String,
      default: ""
    },
    value: {
      type: String,
      default: ""
    },
    disabled: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    loaderPosition: {
      type: String,
      default: "left"
    },
    selectDropdownParent: {
      type: String,
      default: ""
    }
  },
  computed: {
    statusOptions() {
      var _context;
      const options = _mapInstanceProperty(DOCUMENT_STATUSES).call(DOCUMENT_STATUSES, key => ({
        id: key,
        text: this.$t(`documents.status.${key}`) || key
      }));
      const selected = _findInstanceProperty(options).call(options, opt => opt.id === this.value);
      const others = _filterInstanceProperty(options).call(options, opt => opt.id !== this.value);
      return _filterInstanceProperty(_context = [selected, ...others]).call(_context, Boolean);
    },
    options() {
      return {
        closeOnSelect: true,
        allowClear: false,
        placeholder: this.$t("documents.selectDocumentStatus"),
        dropdownCssClass: "form-group-material",
        templateResult: this.formatResult,
        templateSelection: this.formatSelection,
        escapeMarkup: m => m,
        dropdownParent: this.selectDropdownParent || undefined
      };
    }
  },
  methods: {
    handleChange(data) {
      const status = data.id;
      this.$emit("input", status);
      this.$emit("change", status);
      this.$refs.select.setValue(status);
    },
    renderOption(option) {
      const iconClass = documentStatusIcons[option.id] || "";
      return `
    <div style="display: flex; justify-content: space-between; align-items: center;">
      <span>${option.text}</span>
      <i class="${iconClass}" style="font-size: 18px; margin-right: 20px;"></i>
    </div>
  `;
    },
    formatResult(option) {
      if (!option || option.id === this.value) return null;
      return this.renderOption(option);
    },
    formatSelection(option) {
      if (!option || !option.id) {
        return `<span class="text-muted">${this.$t("documents.selectDocumentStatus")}</span>`;
      }
      return this.renderOption(option);
    },
    showLoader(position) {
      return this.loading && this.loaderPosition === position;
    }
  }
});